import { useSearchParams } from "react-router-dom";
import { getUrlQuerysection } from "../helpers";

export const useUrlSearch = () => {
  const queries = getUrlQuerysection();
  const [search, setSearch] = useSearchParams();

  const gotoPage = (pageNumber) => {
    search.set("page", pageNumber);
    setSearch(search, { replace: true });
  };

  const filterByStoreId = (storeId) => {
    if (!storeId) search.delete("store_id");
    else search.set("store_id", storeId);
    search.delete("page");
    setSearch(search, { replace: true });
  };

  const filterBySearch = (value) => {
    if (value?.length === 0) search.delete("query");
    else search.set("query", value);
    search.delete("page");
    setSearch(search, { replace: true });
  };

  const filterByKey = (key, value) => {
    if (value?.length === 0 || !value) search.delete(key);
    else search.set(key, value);
    search.delete("page");
    setSearch(search, { replace: true });
  };

  const filterByDate = (data) => {
    const nextSearch = new URLSearchParams(search.toString());

    if (!data?.startDate) {
      nextSearch.delete("start_date");
    } else {
      nextSearch.set("start_date", data.startDate);
    }

    if (!data?.endDate) {
      nextSearch.delete("end_date");
    } else {
      nextSearch.set("end_date", data.endDate);
    }

    nextSearch.delete("page");
    setSearch(nextSearch, { replace: true });
  };

  const filterByCustomerDate = (key, value) => {
    const nextSearch = new URLSearchParams(search.toString());

    if (!value) nextSearch.delete(key);
    else nextSearch.set(key, String(value));

    nextSearch.delete("page");
    setSearch(nextSearch, { replace: true });
  };

  const getDatePartValue = (searchParamsOrBaseKey, baseKeyOrType, type) => {
    if (type) {
      return searchParamsOrBaseKey?.get?.(`${baseKeyOrType}_${type}`) || "";
    }
    return search.get(`${searchParamsOrBaseKey}_${baseKeyOrType}`) || "";
  };

  const handleDatePartChange = (baseKey, type, nextValue) => {
    const nextSearch = new URLSearchParams(search.toString());

    if (!nextValue) {
      nextSearch.delete(`${baseKey}_${type}`);
    } else {
      nextSearch.set(`${baseKey}_${type}`, String(nextValue));
    }

    nextSearch.delete("page");
    setSearch(nextSearch, { replace: true });
  };

  const changePerPage = (perPage) => {
    if (!perPage) search.delete("per_page");
    else search.set("per_page", perPage);
    search.delete("page");
    setSearch(search, { replace: true });
  };

  return {
    search,
    queries,
    setSearch,
    gotoPage,
    changePerPage,
    filterByStoreId,
    filterBySearch,
    filterByKey,
    filterByDate,
    handleDateRangeFilter: filterByDate,
    filterByCustomerDate,
    getDatePartValue,
    handleDatePartChange,
  };
};
